import React from 'react';
import Carousel from 'react-material-ui-carousel'
import Image from './img/Engaging-an-AC-Compressor-Clutch.jpg'
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Sustain from './img/sustainable.jpg';
import Responsible from './img/responsible.jpg';
import Commitment from './img/commitment.jpg';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Para2 from './img/img/loader1.jpg';
import Para1 from './img/slider/team.jpg';
import Ronak from './img/ronak.jpg';
import Mitul from './img/mitul.jpg';
import Appiah from './img/appiah.jpeg';
import Amit from './img/amit.jpeg';
import Wm from './img/people/wm.jpg';
import Smith from './img/people/smith.jpg';
import Wash from './img/people/wash.jpg';
import Samanth from './img/people/samanth.jpg';
import Doc from './img/people/doctor.jpg';
import Buggan from './img/people/buggan.jpg';
import Ongaga from './img/people/ngoga.jpg';
import Joe from './img/people/joe.jpg';
import Noimage from './img/people/none.png';
import Longman from './img/people/longman.jpg';
import Pambour from './img/people/pambour.jpeg';
import Okello from './img/people/okello.png';
import Lutero from './img/people/Lutero.jpg';
import Fleurot from './img/people/fleurot.jpg';
import Sharlton from './img/people/sharlton.jpg';
import Vil from './img/people/vil.jpg';
import Chrispas from './img/people/chrispas.jpg';

import Avatar from '@material-ui/core/Avatar';
import AOS from 'aos';
import "aos/dist/aos.css";
import Typography from '@material-ui/core/Typography';
import { useSharedStyles, colors } from './sharedStyles';

const imager=[
  {image:Wm ,name:"Elder Wayne M. Bristol", position:"Executive Chairman"},
  {image:Smith ,name:"Elder Winsome G. Smith", position:"Deputy Executive Chairman"},
  {image:Wash ,name:"Mr. George Washington", position:"Executive Secretary"},
  {image:Samanth ,name:"Ms. Samantha Williams CPA", position:"Executive Treasurer"},
  {image:Doc ,name:"Dr. Luke M. Sylvester MD", position:"Medical Outreach Director"},
  {image:Buggan ,name:"Elder Dorrett Buggan", position:"Prayer Director"},
  {image:Chrispas ,name:"Mr. Chrispas Tugumisirize", position:"Community Outreach Director"},
  {image:Joe ,name:"Mr. Ntori Joseph Ngissah ", position:"Communications Director "},
  {image:Longman ,name:"Elder Janice & Duke Longman", position:"Chairman - North America"},

  {image:Noimage ,name:"...", position:"Chairman - Latin America & Caribbean"},
  {image:Pambour ,name:"Pastor A. A. Pambour", position:"Chairman - West Central Africa "},
  {image:Ongaga ,name:"Mr. Timothy Ongaga Oroko", position:"Chairman - East Central Africa"},
  {image:Lutero ,name:"Pastor Lutero Ngola Gange", position:"Chairman - Southern Africa"},
  {image:Fleurot ,name:"Pastor Prisque Haingo", position:"Chairman - Indian Ocean"},
  {image:Sharlton ,name:"Mr. Sharlton Shadrac J.", position:"Chairman - Southern Asia"},
  {image:Vil ,name:"Pastor Viliame N. Ratumaiyale", position:"Chairman - South Pacific"},


];

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `rgba(44, 62, 80, 0)`,
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: colors.white,
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  teamAvatar: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    margin: '0 auto 16px',
    border: `3px solid ${colors.primary}`,
    boxShadow: `0 4px 20px rgba(97, 218, 251, 0.2)`,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
      border: `3px solid ${colors.secondary}`,
    },
  },
  teamName: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: colors.dark,
    marginBottom: '8px',
  },
  teamPosition: {
    color: colors.textLight,
    fontSize: '0.9rem',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    boxShadow: `0 4px 20px rgba(97, 218, 251, 0.15)`,
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    border: `1px solid rgba(97, 218, 251, 0.1)`,
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: `0 12px 40px rgba(97, 218, 251, 0.25)`,
      border: `1px solid rgba(97, 218, 251, 0.3)`,
    },
  },
  cardContent: {
    flexGrow: 1,
    padding: '24px',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: colors.dark,
  },
  cardText: {
    color: colors.textLight,
    lineHeight: 1.6,
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: colors.dark,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '4px',
      background: `linear-gradient(45deg, ${colors.primary}, ${colors.secondary})`,
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  lightSection: {
    background: `linear-gradient(135deg, ${colors.light} 0%, #D1E9FB 100%)`,
    padding: '80px 0',
  },
  mapContainer: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: `0 8px 32px rgba(97, 218, 251, 0.15)`,
    border: `1px solid rgba(97, 218, 251, 0.1)`,
  },
}));

function Example(props){
  AOS.init({
    duration: 800,
    once: true,
    offset: 100
  });
  
  const classes = useStyles();
  
  var items = [
    {
      name: <h1 style={{color: colors.white, fontSize: "3.5rem", marginTop: 0, fontWeight: 700}} data-aos={"fade-up"}>
        <span style={{ paddingLeft: 12, paddingRight: 12, backgroundColor: `rgba(44, 62, 80, 0.8)`, borderRadius: 8, textShadow: '2px 2px 4px rgba(0,0,0,0.5)', border: `2px solid rgba(97, 218, 251, 0.3)`}}>
          About Us
        </span>
      </h1>,
      image: Para1,
      description: ""
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <Carousel swipe={true} indicators={false} touch={true} animation={"slide"} interval={5000}>
        {items.map((item, i) => <Item key={i} item={item} />)}
      </Carousel>

      {/* Main Content Section */}
      <section className={classes.lightSection}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            3AM MISSION MINISTRY
          </Typography>
          
          <Typography variant="h5" style={{textAlign: 'center', marginBottom: '2rem', color: colors.secondary, fontWeight: 600}} data-aos="fade-up">
            Our core purpose is to spread the 3 Angels Message
          </Typography>

          <Typography variant="body1" style={{lineHeight: 1.8, color: colors.text, fontSize: '1.1rem'}} data-aos="fade-up">
            In summer of 2010, <b>Elder Wayne Milton Bristol</b>, volunteered to go to India on a mission trip with the Seabrook Seventh Day Adventist Church, His home church in Lanham, Maryland, USA. He was selected to be the leader of this mission delegation, on this trip he conducted the week of prayer in high schools and presented the health message at the nightly evangelist meeting. <br/><br/>
            Since his first mission trip in 2010, Elder Bristol has been the International Mission Coordinator for His local SDA Church, and has not only had members from His church on mission trips, but from other churches in the Washington DC metropolitan area as well, and in 2018, He had a young Pastor from Ghana and a brother from Kenya joined his team on the mission trip to India as Seabrook celebrated one decade of missionary work in India. <br/><br/>
            Elder Bristol has been blessed to lead many more mission trips to preach the Everlasting gospel and share the love of Jesus in Haiti, Guyana, Kenya, Ethiopia, Fiji and Papua New Guinea to mention but a few. With his great passion for missions, He has formed the <b>WMB MISSION MINISTRIES</b> in spring 2018, with the main objective to mobilize, motivate and educate people to prepare for the second coming of Jesus. <br/><br/>
            In the winter of 2018, officers were elected to serve and lead in the following regions, West - Central Africa, East - Central Africa, Southern Africa - Indian Ocean, Southern Asia and South Pacific. In the spring of 2019, the name was change to <b>3AM MISSION MINISTRY</b> and in the spring of 2020 the regions of North America, Latin America and the Caribbean were added to our area of operations. Would you pray for us, and partner with us, as we go forward into all the world to share the good news that Jesus saves.
          </Typography>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section style={{padding: '80px 0', background: colors.white}}>
        <div className={classes.container}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="100">
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="h4" className={classes.cardTitle}>
                    Our Vision
                  </Typography>
                  <Typography variant="body1" className={classes.cardText}>
                    Our vision is to motivate and serve our communities and demonstrate the love of Jesus.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="200">
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="h4" className={classes.cardTitle}>
                    Our Mission
                  </Typography>
                  <Typography variant="body1" className={classes.cardText}>
                    Our Mission is to mobilize, motivate and educate people to prepare for the second coming of Jesus.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </section>

      {/* Team Section */}
      <section className={classes.lightSection}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Meet Our Team
          </Typography>
          
          <Typography variant="h5" style={{textAlign: 'center', marginBottom: '3rem', color: colors.text, fontWeight: 300}} data-aos="fade-up">
            God has Blessed the 3AM Mission Ministry with a great team to execute this great commission He has given us,<br/> we are honoured to be a part of this great Commission.
          </Typography>

          <Grid container spacing={3}>
            {imager.map((member, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div style={{textAlign: 'center', marginBottom: 30}}>
                  <Avatar 
                    alt={member.name} 
                    src={member.image} 
                    className={classes.teamAvatar}
                  />
                  <Typography variant="h6" className={classes.teamName}>
                    {member.name}
                  </Typography>
                  <Typography variant="body2" className={classes.teamPosition}>
                    {member.position}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </section>

      {/* Map Section */}
      <section style={{padding: '60px 0', background: colors.white}}>
        <div className={classes.container}>
          <div className={classes.mapContainer}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.8484336332685!2d-76.81632558464938!3d38.90458117956952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7eab2795cc2e9%3A0x3b7e3088d8779114!2s1011%20Winged%20Foot%20Dr%2C%20Bowie%2C%20MD%2020721%2C%20USA!5e0!3m2!1sen!2sgh!4v1606680803222!5m2!1sen!2sgh" 
              width="100%" 
              height="400" 
              style={{border: 0}} 
              title="location" 
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
  return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        {props.item.name}
        <Typography variant="h4" style={{color: colors.white, fontSize: '1.2rem', marginTop: '1rem'}} data-aos="fade-up">
          {props.item.description}
        </Typography>
      </div>
    </div>
  );
}

export default Example;


